import { useLocalObservable } from 'mobx-react-lite';

export default function usePrev<T>(initialValue: T): PrevStateType<T> {
  const store = useLocalObservable(() => ({
    _current: initialValue,
    get current() {
      return this._current;
    },
    set current(value: T) {
      this._current = value;
    },
  }));
  return store;
}

export type PrevStateType<T> = { current: T };
